import React, { useEffect } from "react";
import { useTheme } from "emotion-theming";

import { OverlayLoader } from "components/OverlayLoader";
import { PaymentOptionManager } from "./components/PaymentOptionManager";

import { useTimerModal } from "hooks/useTimerModal";
import { getPlatform } from "../../helpers";
import { trackAddressPaymentBottomsheetLoads } from "wrapper/NewAddressWrapper/dependencies/tracking";

import { PAYMENT_FLOWS } from "constants/payment";
import { DEVICE_TYPE } from "../../constants";

export const AddressPaymentSection = ({
  isPaymentBottomSheetVisisble,
  setIsPaymentBottomSheetVisisble,
  paymentOptionConfig,
  paymentInfo,
  isGuest,
  loading,
  setLoading,
  totalSaved,
  orderAmount,
  doPayment,
  cartInfo,
}: IAddressPaymentSection) => {
  const theme: Theme = useTheme();
  const platform = getPlatform();

  const { timerCallback, upiTimerConfig, setUpiDetails } = useTimerModal({
    paymentInfo,
    isGuest,
    theme,
    deviceType: DEVICE_TYPE.MOBILE,
    platform,
    flow: PAYMENT_FLOWS.CHECKOUT,
    setLoading,
  });

  useEffect(() => {
    /**
     * track address payment bottom sheet loads.
     */
    if (isPaymentBottomSheetVisisble) {
      const paymentBottomsheetLoadsProperty = {
        interaction_location: "addNewAddress",
        payment_methods_shown: ["upi", "cod"],
        payment_methods_recommended: ["upi", "cod"],
        default_payment_method: paymentOptionConfig.mode,
        cart_total_modified: cartInfo.bagTotal,
        cart_subtotal_modified: cartInfo.subTotal,
        mrp_discount_modified: totalSaved,
        cart_display_amount_modified: orderAmount,
        cart_total_qty: cartInfo.quantity,
        cart_product_count: cartInfo.itemCount,
      };
      trackAddressPaymentBottomsheetLoads(paymentBottomsheetLoadsProperty);
    }

  }, [isPaymentBottomSheetVisisble]);

  const togglePaymentMethodSheet = (value: boolean) => {
    setIsPaymentBottomSheetVisisble(value);
  }

  // upi config
  const upiConfig = {
    cartRules: {}, // offers not integrated
    doPayment,
    isAccordianOpened: true,
    toggleNewPaymentAccordian: () => {},
    endIcon: "",
    timerCallback,
    setUpiDetails,
    isDisabled: false,
    isGPayIntentAvailable: false,
    toggleOfferBottomSheet: () => {}, // offers not integrated
    hideHeader: true,
    isButtonFixedToBottom: true,
  };

  //cod config
  const codConfig = {
    doPayment,
    isAccordianOpened: false,
    toggleNewPaymentAccordian: () => {},
    endIcon: "",
    paymentFailureFlow: false,
    isDisabled: false,
    newPaymentMethodWithPriority: [],
    newPaymentMethod: [],
    isButtonFixedToBottom: true,
  };

  const savingText = `Continue saving <span style = "color:${theme.colors.positive};">₹${totalSaved}</span> on this order`;

  return (
    <>
      <OverlayLoader isActive={loading} zIndex={3} />

      {/* change payment method bottom sheet */}
      <PaymentOptionManager
        cartInfo = {cartInfo}
        upiTimerConfig={upiTimerConfig}
        savingText={savingText}
        codConfig={codConfig}
        upiConfig={upiConfig}
        paymentOptionConfig={paymentOptionConfig}
        orderAmount={orderAmount}
        paymentMethodSheetVisible={isPaymentBottomSheetVisisble}
        togglePaymentMethodSheet={togglePaymentMethodSheet}
        isGuest={isGuest}
        theme={theme}
      />
    </>
  );
};
